import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DownloadFile } from "./scenarioApprovalSlice";
import {
   DownloadOutlined,
   SpeakerNotesOutlined,
} from "@mui/icons-material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {  Stack} from "@mui/material";

export default function Comments() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.scenarioApproval);

   const {
      scenariosForApprovalTable, scenarioDetails
   } = state;  
   if (scenarioDetails === null) {
      return null;
   }

   const {comments, scenarioFiles} = scenarioDetails
   const handleDownloadFile = (filepath) =>{
      dispatch(DownloadFile(filepath));
   }
   return ( 
      scenariosForApprovalTable && (
      <Box sx={{ mt: 2 }}>
         {scenarioFiles?.length > 0 && (
                  <Stack direction="row" alignItems="center" gap={2}>
                     <Typography sx={{ color: "#007DC3", fontWeight: "bold" }}>
                     <AttachFileIcon  color="info" />
                        Attachments
                     </Typography>
                  </Stack>
                )} 
               <Table>
                  <TableBody>
                     {scenarioFiles?.map((row) => { 
                        return (
                           <TableRow className="tableRow" key={row?._id}>
                              <TableCell
                                 className="tableCell"
                                 sx={{ flexGrow: 1 }}
                              >
                                 {row.filePath}
                              </TableCell>
                              <TableCell className="tableCell">
                                 <Button
                                    variant="outlined"
                                    startIcon={<DownloadOutlined />}
                                    size="small"
                                    onClick={() => handleDownloadFile(row.filePath)}
                                 >
                                    Download
                                 </Button>{" "}
                              </TableCell>
                           </TableRow>
                        );
                     })} 
                  </TableBody>
               </Table>
         <div>
         <Stack direction="row" alignItems="center" gap={2}>
               
                  <Typography sx={{ color: "#007DC3", fontWeight: "bold", width:"100%" }}>
                  <SpeakerNotesOutlined sx={{transform:" translate(0px, 6px)",width: 20, mr: 1,}} color="info" />
                     Comments
               </Typography>
            </Stack>
         </div>

         <div>
            <TextField className={'fullWidth'}
               size="large"
               multiline
               rows={6}
               style={{overflowY:'auto'}}
               value={comments}
               disabled
              // inputProps={{ style: { width: 400 } }}
            />
         </div>

         {/* <div>
            <Button
               sx={{
                  width: 40,
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
            >
               View
            </Button>
         </div> */}
      </Box>
      )
   );
}
